<div class="c-wrapper">
    <div class="c-tab">
        <button matRipple [class.btnactive]="currentTab === 1" (click)="currentTab = 1">Übersicht</button>
        <button matRipple [class.btnactive]="currentTab === 2" (click)="currentTab = 2">Route</button>
        <button matRipple [class.btnactive]="currentTab === 3" (click)="currentTab = 3">Schiff</button>
        <button matRipple [class.btnactive]="currentTab === 4" (click)="currentTab = 4">Kabinen</button>
        <button matRipple [class.btnactive]="currentTab === 5" (click)="currentTab = 5">Deckplan</button>
        <button matRipple [class.btnactive]="currentTab === 6" (click)="currentTab = 6">Leistungen</button>
    </div>
    <div class="c-n-wrapper customscroll">
        <ng-container *ngIf="currentTab === 1">
            <div class="topw">
                <span multilang class="c-title">{{booking.infolines}}</span>
            </div>
            <div class="dg-info-item mt">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Reisezeitraum:</span>
                <span multilang>{{catalog.schedule?.[0]?.cruise_start_date | date:'dd.MM.yyyy'}} -
                    {{catalog.schedule?.[0]?.cruise_end_date | date:'dd.MM.yyyy'}}</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Dauer:</span>
                <span multilang>{{catalog.schedule?.[0]?.cruise_duration}} {{catalog.schedule?.[0]?.cruise_duration
                    ===
                    '1' ?
                    'Nacht' : 'Nächte'}}</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Kabin:</span>
                <span multilang>{{cabin?.name}}</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Starthafen:</span>
                <span multilang>{{catalog?.routing?.[0]?.portname}} ({{catalog?.routing?.[0]?.country}})</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Zielhafen:</span>
                <span multilang>{{catalog?.routing?.[catalog?.routing.length - 1]?.portname}}
                    ({{catalog?.routing?.[catalog?.routing.length - 1]?.country}})</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Reederei:</span>
                <span multilang>{{booking?.touroperator_name}}</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Schiff:</span>
                <span multilang>{{catalog?.ship?.[0]?.name}}</span>
            </div>

            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Flug:</span>
                <ng-container *ngIf="cabin?.incl_flight === 1 else noflight">
                    <span multilang>
                        {{cabin?.start_source_airport_name}} ({{cabin?.start_source_airport_code}}) /
                        {{cabin?.start_dest_airport_name}} ({{cabin?.start_dest_airport_code}})
                    </span>
                </ng-container>
                <ng-template #noflight>
                    <span multilang style="color: red;">ohne Flüge</span>
                </ng-template>
            </div>



            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Tarif:</span>
                <span multilang>{{cabin?.preismodelcode}}</span>
            </div>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Verpflegung:</span>
                <span multilang>{{cabin?.cruise?.board_name}}</span>
            </div>
            <ng-container *ngIf="cabin?.incl_transfer === 1">
                <div class="dg-info-item">
                    <span multilang [class.dg-info-item-first]="deskMode"
                        [class.dg-info-item-first-mobile]="!deskMode">Transfer:</span>
                    <span multilang>inkl. Transfer</span>
                </div>
            </ng-container>
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Info:</span>
                <span multilang>{{cabin?.promo_description}}</span>
            </div>

            <ng-container *ngIf="package?.name?.length > 0">
                <div class="c-block">
                    <div class="c-item">
                        <span multilang class="c-item-title">Hotel: {{cabin?.hotel.tage_hotel +
                            (cabin?.hotel.tage_hotel
                            === 1 ?
                            'Nacht' : ' Nächte')}} ({{(cabin.hotel.start_hotel | date )+ ' - ' + (cabin.hotel.ende_hotel
                            | date)}})</span>
                        <div class="offerprice">
                            <span multilang class="f400">{{package.name}}</span>
                            <div class="imgw">
                                <ng-container *ngFor="let im of package.images;let k=index">
                                    <img *ngIf="im?.length > 0" (click)="openImageModal(k)"
                                        src="{{im | cacheResource}}" class="lazyload myimg">
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="c-block">
                <div class="c-item">
                    <span multilang class="c-item-title">Preis</span>
                    <div class="offerprice">
                        <span multilang class="f400">{{travelerText}}</span>
                        <span multilang multilang deeplMode='html' [innerHtml]="prcdetail | safehtml"></span>
                        <div class="offerpriceTotal">
                            <span multilang>Gesamtpreis:</span>
                            <span multilang class="prccolor ml">{{booking?.pricedetails?.provider?.[0].total |
                                number:'1.2-2'}}
                                {{booking?.total_currency}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="booking?.extracomment?.length > 0">
                <div class="c-block">
                    <div class="c-item">
                        <span multilang class="c-item-title">Extra info</span>
                        <div class="v-wrapper">
                            <pre class="ml pree">{{booking?.extracomment}}</pre>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="c-block">
                <div class="c-item">
                    <span multilang class="c-item-title">Flugdetail</span>
                    <ng-container *ngIf="cabin?.incl_flight === 1 else ohneFlug">
                        <div class="alert-primary">
                            <span multilang>
                                Unbekannte Flugdaten werden Ihnen rechtzeitig vor Ihrer Reise mitgeteilt.
                            </span>
                        </div>
                    </ng-container>
                    <ng-template #ohneFlug>
                        <span multilang style="color: red;">ohne Flüge</span>
                    </ng-template>
                </div>
            </div>

            <div class="c-block">
                <ng-container *ngIf="catalog?.provider?.[0]?.name?.length > 0">
                    <div class="c-item">
                        <span multilang class="c-item-title">Veranstalter</span>
                        <div class="v-wrapper">
                            <img *ngIf="catalog?.provider?.[0]?.logo?.length > 0"
                                src="{{catalog?.provider?.[0]?.logo}}" class="lazyload" height="24px"
                                alt="{{catalog?.provider?.[0]?.name}}">
                            <span multilang class="ml">{{catalog?.provider?.[0]?.name}}
                                ({{catalog?.provider?.[0]?.vc}})</span>
                            <span multilang class="ml ul"><a multilang [href]="booking?.touroperator_url_agb"
                                    target="blank">AGB</a></span>
                            <ng-container *ngIf="booking?.nat?.DE?.length > 0">
                                <span multilang class="ml ul"><a multilang [href]="booking?.nat?.DE"
                                        target="blank">Einreisebestimmungen</a></span>
                            </ng-container>
                            <ng-container *ngIf="booking?.touroperator_url_covid_form?.length > 0">
                                <span multilang class="ml ul"><a multilang [href]="booking?.touroperator_url_covid_form"
                                        target="blank">COVID</a></span>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="currentTab === 2">
            <div class="c-block resmt">
                <div class="c-item">
                    <span multilang class="c-item-title">Reiseverlauf</span>
                    <div class="flexy">
                        <h2 multilang class="mt05">{{catalog?.itineraries?.[0]?.itinerary_name}}</h2>
                        <div class="route">
                            <ng-container *ngTemplateOutlet="schedul"></ng-container>
                            <img *ngIf="catalog?.itineraries?.[0]?.itinerary_image?.length > 0"
                                src="{{catalog?.itineraries?.[0]?.itinerary_image}}"
                                alt="{{catalog?.itineraries?.[0]?.itinerary_name}}" class="lazyload myimg">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="currentTab === 3">
            <div class="c-block resmt">
                <div class="c-item">
                    <span multilang class="c-item-title">Schiff</span>
                    <div class="flexy">
                        <img *ngIf="catalog?.ship?.[0]?.image?.length > 0" src="{{catalog?.ship?.[0]?.image}}"
                            alt="{{catalog?.ship?.[0].name}}" class="lazyload myimg">
                    </div>
                    <ng-container *ngIf="catalog?.ship?.[0]?.covid_info?.length > 0">
                        <div class="flexy">
                            <h2 multilang class="mt05">Covid info</h2>
                            <div multilang deeplMode='html' [innerHtml]="catalog?.ship?.[0]?.covid_info"></div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="catalog?.ship?.[0]?.desc?.length > 0">
                        <div class="flexy">
                            <h2 multilang class="mt05">Schiff info</h2>
                            <div multilang deeplMode='html' [innerHtml]="catalog?.ship?.[0]?.desc"></div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="currentTab === 4">
            <div class="c-block resmt">
                <div class="c-item">
                    <span multilang class="c-item-title">Kabinen</span>
                    <div class="cab-wr">
                        <span multilang class="cab-t">{{currentCabin.cabin_name}}
                            [{{currentCabin.cabin_type}}]</span>
                        <span multilang class="cab-subt">Belegung: {{currentCabin?.cabin_min_persons}} bis
                            {{currentCabin?.cabin_max_persons}} Personen</span>
                        <ng-container *ngIf="currentCabin?.equipments?.length > 0">
                            <div class="cab-inf">
                                <div *ngFor="let inf of currentCabin?.equipments" class="cabinfo">
                                    &#8212; {{inf}}
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <img class="lazyload myimg" *ngIf="currentCabin.cabin_image?.length > 0"
                        src="{{currentCabin.cabin_image}}" alt="kabin">
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="currentTab === 5">
            <div class="c-block resmt">
                <div class="c-item">
                    <span multilang class="c-item-title">Deckplan</span>
                    <app-cruisedeckplan style="width: inherit;" [deckplan_legend]="catalog?.deckplan_legend"
                        [desktopTemplate]="desktopTemplate" [decks]="catalog?.decks">
                    </app-cruisedeckplan>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="currentTab === 6">
            <div class="c-block resmt">
                <div class="c-item">
                    <span multilang class="c-item-title">Leistungen</span>
                    <app-cruiseleistungen style="width: inherit;" [excluded_features]="catalog?.excluded_features"
                        [desktopTemplate]="desktopTemplate" [included_features]="catalog?.included_features"
                        [included_infos]="catalog?.included_infos">
                    </app-cruiseleistungen>
                </div>
            </div>
        </ng-container>

    </div>
    <div class="f-btn-wrapper">
        <button class="f-btn colorB" matRipple (click)="sendBooking()">Jetzt buchen</button>
        <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
    </div>
</div>

<div class="fixedlefttop">
    <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
    <button class="f-b-top" matRipple (click)="sendBooking()">Jetzt buchen</button>
</div>

<ng-template #schedul>
    <table class="table">
        <thead>
            <tr>
                <th>Tag</th>
                <th>Dateum</th>
                <th>Hafen</th>
                <th>Ankunft</th>
                <th>Abfahrt</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let rt of catalog?.routing; let k=index;" [class.stripedtrEven]="k%2 === 0"
                [class.stripedtrOdd]="k%2 !== 0">
                <td>{{rt.day}}</td>
                <td>{{rt.date | date}}</td>
                <td>{{rt.portname?.length > 0 ? rt.country + ', ' + rt.portname : 'Tag auf See'}}</td>
                <td>{{rt.arrival}}</td>
                <td>{{rt.departure}}</td>
            </tr>
        </tbody>
    </table>
</ng-template>